import * as React from 'react';
import { Controller, Toolbar, Menu, CustomArgs } from '@tencent/workbench';
import { BorderStyleFeature } from './border-style-feature';
import { TOOLBAR_ITEMS, config, MENU_CONFIGS } from './config';
import { wrapIdForBig, wrapIdForPic, wrapIdForTableTabInput, wrapIdForText } from '@framework/workbench/util/wrap-id-util';

@Controller({
    toolbarItems: TOOLBAR_ITEMS,
    menuItems: MENU_CONFIGS,
})
export class BorderStyleController {
    constructor(private readonly feature: BorderStyleFeature) {
    }

    @Toolbar(config.id, 'dropdownContent', { useStyle: true })
    @Toolbar(wrapIdForBig(config.id), 'dropdownContent', { useStyle: true })
    @Toolbar(wrapIdForText(config.id), 'dropdownContent', { useStyle: true })
    @Toolbar(wrapIdForTableTabInput(config.id), 'dropdownContent', { useStyle: true })
    @Toolbar(wrapIdForPic(config.id), 'dropdownContent', { useStyle: true })
    @Menu(config.id, 'content', { useStyle: false })
    public showContent(@CustomArgs() args: { useStyle: boolean }) {
        return this.feature.showContent(args.useStyle);
    }

    @Toolbar(config.id, 'shouldHide')
    @Toolbar(wrapIdForBig(config.id), 'shouldHide')
    @Toolbar(wrapIdForText(config.id), 'shouldHide')
    @Toolbar(wrapIdForTableTabInput(config.id), 'shouldHide')
    @Toolbar(wrapIdForPic(config.id), 'shouldHide')
    public shouldHide() {
        return this.feature.shouldHide();
    }
}
